/**
 * Notification Preferences Service — API client for managing the
 * authenticated user's notification preferences.
 *
 * Requirements: 12.4
 */

import { apiClient } from '@/services/apiClient';

// ─── Types ─────────────────────────────────────────────────────────────

export interface NotificationPreference {
  notificationType: string;
  enabled: boolean;
}

export interface UpdatePreferencesInput {
  preferences: NotificationPreference[];
}

// ─── Service ───────────────────────────────────────────────────────────

export const notificationPreferencesService = {
  /** GET /api/notifications/preferences — Get the authenticated user's preferences. */
  getPreferences(): Promise<NotificationPreference[]> {
    return apiClient.get<NotificationPreference[]>('notifications/preferences');
  },

  /** PUT /api/notifications/preferences — Update the authenticated user's preferences. */
  updatePreferences(input: UpdatePreferencesInput): Promise<NotificationPreference[]> {
    return apiClient.put<NotificationPreference[]>('notifications/preferences', input);
  },
};
